import React, { Component } from "react";
import styles from "./winterMaintenceMapWrapper.module.scss";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";
import { Radio } from "@mui/material";
import { states } from "../../../reducers/queriesStates";
import Preloader from "../../../shared/items/static/preloader";

class WinterMaintenceViewSwitcher extends Component {
  render() {
    const { openCompaniesInfoState, onSetWinteCompaniesInfo, winterCompaniesRoutesDataState, winterAreasDataState, winterAreas } =
      this.props;

    return (
      <div className={styles.switcherContainer}>
        <div style={{ marginRight: "15px" }}>
          <Radio
            className={styles.MuiRadio_resolve}
            checked={openCompaniesInfoState === 0}
            size="small"
            onClick={() => {
              onSetWinteCompaniesInfo(0);
            }}
          />
          <span> Карта</span>
        </div>

        {winterCompaniesRoutesDataState === states.NOT_REQUESTED ? (
          <div style={{ marginRight: "15px", display: "flex" }}>
            <Radio
              className={styles.MuiRadio_resolve}
              checked={openCompaniesInfoState === 1}
              size="small"
              onClick={() => {
                onSetWinteCompaniesInfo(1);
              }}
              style={{ padding: "0px !important" }}
            />

            <span style={{ marginRight: "15px" }}>Сведенья</span>

            {winterCompaniesRoutesDataState === states.NOT_REQUESTED &&
            winterAreasDataState === states.REQUEST &&
            winterAreas.length > 0 ? (
              <Preloader size={20} />
            ) : null}
          </div>
        ) : null}

        {winterCompaniesRoutesDataState === states.READY ? (
          <div>
            <Radio
              className={styles.MuiRadio_resolve}
              checked={openCompaniesInfoState === 2}
              size="small"
              onClick={() => {
                onSetWinteCompaniesInfo(2);
              }}
              style={{ padding: "0px !important" }}
            />
            <span>Сведения за период</span>
          </div>
        ) : null}
      </div>
    );
  }
}

export default withWinterMaintence(React.memo(WinterMaintenceViewSwitcher));
